import axios, { AxiosPromise } from 'axios';

import { IUnitOfMeasure } from '../../../@types/model/masterData/unitOfMeasure/unitOfMeasure';

export default class UnitOfMeasureHttpService {
    public static getUnitOfMeasureData() : AxiosPromise<Array<IUnitOfMeasure>> {
        return axios.get(`${API_URL}/v1/UnitOfMeasure/GetAllWeb`);
    }

    public static addOrUpdateUnitOfMeasure(data : IUnitOfMeasure) : AxiosPromise<IUnitOfMeasure> {
        return axios.post(`${API_URL}/v1/UnitOfMeasure/PostUnitOfMeasure`, data);
    }

    public static deleteUnitOfMeasure(unitOfMeasureId : number) : AxiosPromise<IUnitOfMeasure> {
        return axios.delete(`${API_URL}/v1/UnitOfMeasure/Delete`, {
            params : { unitOfMeasureId },
        });
    }
}
